import { PartnerOnboardingStatus } from "../../partnerportal/models/partner-onboarding";

export class PartnerSearch {
    PartnerId: number;
    PartnerName: string; 
    MainIdentificationName: string;
    MainIdentificationValue: string;
    EdiPortalId: string;
    PartnerTypeName: string;
    DecimalMark: string;
    LatestDocumentDate: Date;
    IsProxyPartner: boolean;
    TagsNames: string[];
    PartnerTags: string;
    PartnerOnboardingStatus: PartnerOnboardingStatus;
    PartnerOnboardingData: string;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}
